import React, { useState, useRef, useEffect } from 'react';

function QRScanner({ onScan, onClose }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [cameraError, setCameraError] = useState(false);
  const [code, setCode] = useState('');

  useEffect(() => {
    startCamera();
    return () => stopCamera();
  }, []);

  const startCamera = async () => {
    try {
      // Vérifier si on est en HTTPS (requis pour caméra)
      if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
        setCameraError(true);
        return;
      }
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' }
      });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play().catch(() => {});
      }
    } catch (e) {
      console.log('Camera error:', e);
      setCameraError(true);
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
    }
  };

  const handleSubmit = () => {
    if (code.length >= 6) {
      stopCamera();
      onScan(code.toUpperCase());
    }
  };

  return (
    <div className="qr-scanner-overlay" onClick={onClose}>
      <div className="qr-scanner-modal" onClick={e => e.stopPropagation()}>
        <div className="qr-scanner-header">
          <h3>📷 Rejoindre une Party</h3>
          <button onClick={() => { stopCamera(); onClose(); }}>✕</button>
        </div>

        {!cameraError && (
          <div className="qr-scanner-video-wrap">
            <video ref={videoRef} className="qr-scanner-video" playsInline muted />
            <div className="qr-scanner-frame" />
            <div className="qr-scanner-camera-hint">Positionnez le QR code dans le cadre</div>
          </div>
        )}

        {cameraError && (
          <div className="qr-scanner-no-camera">
            <div className="qr-scanner-no-camera-icon">📷</div>
            <p>Caméra non disponible</p>
            <p className="qr-scanner-no-camera-sub">La caméra nécessite une connexion HTTPS.<br/>Entrez le code manuellement :</p>
          </div>
        )}

        <div className="qr-scanner-manual">
          <input
            className="qr-scanner-input"
            maxLength={8}
            placeholder="CODE DE LA PARTY"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            autoFocus
          />
          <button className="qr-scanner-join-btn" onClick={handleSubmit} disabled={code.length < 6}>
            Rejoindre
          </button>
        </div>
      </div>
    </div>
  );
}

export default QRScanner;
